module.exports = __webpack_public_path__ + "media/images/solo-200-new-e7d194aae81ad031d5f052a1bf1f5a85.webp";